module.exports = __webpack_public_path__ + "static/media/pink-circle.cbd946d4.png";